<template>
  <div
    v-if="true === geoWerftData.interactive_filter_active"
    v-bind:class="mw_get_main_filter_class(geoWerftData)"
  >
    <div
      v-for="(filter, filterIndex, count) in geoWerftData.filter"
      class="interactive-filter-wrapper"
      v-bind:class="
        handle_field_visibility(filter, filterIndex, count, geoWerftData)
      "
    >
      <!--Checkboxen|Radio-->
      <template
        v-if="
          ('epass_wertklasse' !== filterIndex &&
            filter.options &&
            filter.type === 'checkbox') ||
          filter.type === 'radio'
        "
      >
        <div
          class="single-interactive-input-wrapper"
          v-for="(arr_label_value, index) in filter.options"
          v-bind:class="
            interactive_filter_cb_status_class(filter, arr_label_value.value)
          "
        >
          <input
            v-bind:id="'single-interactive-option-' + arr_label_value.value"
            v-bind:type="filter.type"
            v-model="filter.value"
            v-bind:value="arr_label_value.value"
            v-bind:name="filterIndex"
            v-on:change="remove_filters_not_set()"
            v-bind:checked="
              interactive_filter_set_selected(
                filter,
                arr_label_value.value,
                'checkbox'
              )
            "
          />
          <label
            v-bind:for="'single-interactive-option-' + arr_label_value.value"
            v-html="arr_label_value.label"
          ></label>
        </div>
      </template>
      <!--Selects-->
      <template v-if="'select' === filter.type">
        <div
          class="single-interactive-input-wrapper"
          v-bind:class="filterIndex + '-select'"
        >
          <select
            v-bind:id="'single-interactive-option-' + filterIndex"
            v-model="filter.value"
            v-bind:name="filterIndex"
          >
            <option value="" v-html="filter.label"></option>
            <option
              v-for="(arr_label_value, index) in filter.options"
              v-bind:value="arr_label_value.value"
              v-html="arr_label_value.label"
              v-on:change="remove_filters_not_set()"
              v-bind:selected="
                interactive_filter_set_selected(filter, arr_label_value.value)
              "
            ></option>
          </select>
        </div>
      </template>
      <!--Textfelder-->
      <template v-if="'text' === filter.type">
        <div
          class="single-interactive-input-wrapper"
          v-bind:class="filterIndex + '-select'"
        >
          <label
            v-bind:for="'single-interactive-option-' + filterIndex.value"
            v-html="filter.label"
          ></label>
          <input
            v-bind:id="'single-interactive-option-' + filterIndex"
            v-bind:type="filter.type"
            v-model="filter.value"
            v-bind:value="filter.value"
            v-bind:name="filterIndex"
            v-on:change="interactive_filter_format_value(filter)"
            v-bind:inputmode="interactive_filter_input_mode(filter)"
            @focus="$event.target.select()"
            v-bind:placeholder="filter.placeholder"
          />
        </div>
      </template>
      <!--Energieeffizienzklasse-->
      <template v-if="'epass_wertklasse' === filterIndex">
        <div
          class="single-interactive-input-wrapper"
          v-for="(arr_label_value, index) in filter.options"
          v-bind:class="
            interactive_filter_cb_status_class(filter, arr_label_value.value)
          "
        >
          <div
            class="single-epass-pair"
            v-bind:class="arr_label_value.value.replace('a+', 'a-plus')"
          >
            <input
              v-bind:id="
                'single-interactive-option-' +
                arr_label_value.value.replace('a+', 'a-plus')
              "
              v-bind:type="filter.type"
              v-model="filter.value"
              v-bind:value="arr_label_value.value"
              v-bind:name="filterIndex"
              v-on:change="handleCheckboxChange(filter, $event)"
            />
            <label
              v-bind:for="
                'single-interactive-option-' +
                arr_label_value.value.replace('a+', 'a-plus')
              "
              v-html="arr_label_value.label"
            ></label>
          </div>
        </div>
      </template>
    </div>
    <!--    Hier kommen nun ggf. weitere Elemente dazu.-->
    <!--    - Karten und Listen schalter-->
    <!--    - Sucher verfeinern schalter-->
    <!--    - Mobile Search?-->
    <div
      v-if="geoWerftData.show_more_filter"
      v-html="geoWerftData.show_more_filter.label.inactive"
      class="interactive-filter-show-more-button inactive"
      v-on:click="
        trigger_show_more_filter_actions(geoWerftData.show_more_filter, $event)
      "
    ></div>
    <div
      v-if="geoWerftData.show_dialog_filter"
      v-on:click="show_dialog_filter()"
      v-html="geoWerftData.show_dialog_filter.label"
      class="interactive-filter-open-dialog no-filters-set"
    ></div>
    <dialog
      tabindex="-1"
      v-if="geoWerftData.show_dialog_filter"
      id="mw-interactive-show-all-filter-dialog-wrapper"
      class="mw-block-modal mw-show-map-app-filter"
    >
      <div id="mw-interactive-show-all-filter-dialog">
        <div
          onclick="this.closest( 'dialog' ).close();"
          class="ben-modal-close-wrapper"
          v-html="geoWerftData.show_dialog_filter.icon"
        ></div>
      </div>
      <button
        onclick="this.closest( 'dialog' ).close();"
        class="mw_interactive_filter_close_btn"
        v-html="geoWerftData.show_more_filter_close_btn_label"
      ></button>
    </dialog>
    <div
      class="mw-geo-advanced-filter-map-list-switch-wrapper"
      v-if="true === geoWerftData.display_map_list_switch"
    >
      <div class="geowerft-switcher-buttons-wrapper">
        <div class="geowerft-switcher-buttons-inner">
          <button
            v-on:click="
              handle_listen_click(1, true, geoWerftData.filter, 'list')
            "
            class="geowerft-switcher-tablinks geowerft-switcher-left"
          >
            Listenansicht
          </button>
          <button
            v-on:click="
              handle_listen_click(init_zoom, false, geoWerftData.filter, 'map')
            "
            class="geowerft-switcher-tablinks geowerft-switcher-right active"
          >
            Kartenansicht
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="object-filter-wrapper">
    <ul
      class="object-filter"
      :class="
        (geoWerftData.checkboxes.display_marketing_method &&
          geoWerftData.extra_class) ||
        (geoWerftData.checkboxes.list_map_switcher &&
          display_filter &&
          'geolagen-select')
      "
    >
      <li
        v-for="(filter, filterIndex) in geoWerftData.filter"
        class="go-filters-art"
        v-bind:class="filterIndex"
      >
        <template v-if="filter.options">
          <label v-bind:for="filterIndex">{{ filter.label }}</label>
          <select
            v-if="filterIndex === 'regio'"
            :class="false === display_filter ? 'mw-hide' : 'show'"
            v-bind:id="filterIndex"
            v-bind:name="filterIndex"
            v-model="filter.value"
            v-on:change="handel_option_click(filter.value)"
          >
            <option v-if="filter.label !== ''" value="" selected="selected">
              {{ filter.label }} wählen
            </option>
            <option
              v-for="(option, optionIndex) in filter.options"
              v-bind:value="optionIndex"
            >
              {{ option }}
            </option>
          </select>
          <select
            v-else
            v-bind:id="filterIndex"
            v-bind:name="filterIndex"
            v-model="filter.value"
            v-on:change="handel_option_click(filterIndex, filter.value)"
          >
            <option v-if="filter.label !== ''" value="" selected="selected">
              {{ filter.label }} {{ filter.extension }}
            </option>
            <option
              v-for="(option, optionIndex) in filter.options"
              v-bind:value="optionIndex"
            >
              {{ option }}
            </option>
          </select>
        </template>
        <!--Anpassung: Mögliche Checkboxen im Filter-->
        <template v-else-if="filter.type && filter.type === 'checkbox'">
          <input
            v-bind:id="filter.id"
            type="checkbox"
            v-model="filter.value"
            v-bind:value="filter.option"
            v-bind:name="filter.label.toLowerCase()"
          />
          <label
            v-bind:for="filter.id"
            v-html="filter.label"
            v-bind:title="filter.label"
            >{{ filter.label }}</label
          >
        </template>
        <!--Anpassung: Mögliche Checkboxen im Filter Ende-->
        <template v-else-if="filter.input === 'kennung'">
          <label v-bind:for="filterIndex">{{ filter.label }}</label>
          <input
            class="mw-geowerft-id-filter"
            v-bind:id="filterIndex"
            v-bind:name="filterIndex"
            v-model="filter.value"
            :placeholder="geoWerftData.kennung_filter_placeholder"
          />
        </template>
        <template v-else-if="filter.input === 'energie'">
          <label v-bind:for="filterIndex">{{ filter.label }}</label>
          <select
            class="mw-geowerft-energie-filter"
            v-model="filter.value"
            v-bind:id="filterIndex"
            v-bind:name="filterIndex"
          >
            <option
              selected="selected"
              value=""
              v-html="geoWerftData.energie_filter_placeholder"
            ></option>
            <option value="A+">bis A+</option>
            <option value="A">bis A</option>
            <option value="B">bis B</option>
            <option value="C">bis C</option>
            <option value="D">bis D</option>
            <option value="E">bis E</option>
            <option value="F">bis F</option>
            <option value="G">bis G</option>
            <option value="H">bis H</option>
          </select>
        </template>
        <template v-else>
          <ul
            class="geo-filters"
            :class="
              geoWerftData.checkboxes.display_marketing_method &&
              geoWerftData.extra_class_nums
            "
          >
            <li>
              <label v-bind:for="filterIndex + '-min'"
                >{{ filter.label }}
                <span class="hidden" aria-readonly="true"> von</span></label
              >
              <input
                v-if="
                  [
                    geoWerftData.texts.filter_label_price,
                    geoWerftData.texts.filter_label_price_buy,
                    geoWerftData.texts.filter_label_price_rent,
                    geoWerftData.texts.filter_adults_label,
                    geoWerftData.texts.filter_children_label,
                  ].includes(filter.label)
                "
                type="number"
                value=""
                v-bind:step="get_correct_step(filter.label)"
                v-bind:id="filterIndex + '-min'"
                v-bind:name="filterIndex + '-min'"
                v-bind:placeholder="
                  get_pre_filter_labels(filter.label, 'von') +
                  filter.price_min_extension
                "
                v-bind:title="
                  get_pre_filter_labels(filter.label, 'von') +
                  filter.price_min_extension
                "
                v-model.number="filter.value.min"
                min="0"
              />
              <input
                v-if="
                  filter.label.toLowerCase() ===
                  geoWerftData.texts.filter_label_rooms.toLowerCase()
                "
                type="number"
                value=""
                v-bind:step="get_correct_step(filter.label)"
                v-bind:id="filterIndex + '-min'"
                v-bind:name="filterIndex + '-min'"
                v-bind:placeholder="
                  get_pre_filter_labels(filter.label, 'von') +
                  filter.rooms_min_extension
                "
                v-model.number="filter.value.min"
                min="0"
              />
              <input
                v-if="
                  [
                    geoWerftData.texts.filter_label_space,
                    geoWerftData.texts.filter_space_label_house,
                    geoWerftData.texts.filter_space_label_grundstueck,
                    geoWerftData.texts.filter_space_label_gewerbe,
                    geoWerftData.texts.filter_space_label_invest,
                  ].includes(filter.label)
                "
                type="number"
                value=""
                v-bind:step="get_correct_step(filter.label)"
                v-bind:id="filterIndex + '-min'"
                v-bind:name="filterIndex + '-min'"
                v-bind:placeholder="
                  get_pre_filter_labels(filter.label, 'von') +
                  filter.space_min_extension
                "
                v-model.number="filter.value.min"
                min="0"
              />
            </li>
            <li>
              <label v-bind:for="filterIndex + '-max'"
                ><span class="hidden" aria-readonly="true"> bis</span></label
              >
              <input
                v-if="
                  [
                    geoWerftData.texts.filter_label_price,
                    geoWerftData.texts.filter_label_price_buy,
                    geoWerftData.texts.filter_label_price_rent,
                    geoWerftData.texts.filter_adults_label,
                    geoWerftData.texts.filter_children_label,
                  ].includes(filter.label)
                "
                type="number"
                value=""
                v-bind:step="get_correct_step(filter.label)"
                v-bind:id="filterIndex + '-max'"
                v-bind:name="filterIndex + '-max'"
                v-bind:placeholder="
                  filter.pre_max ? filter.pre_max : filter.price_max_extension
                "
                v-bind:title="
                  filter.pre_max ? filter.pre_max : filter.price_max_extension
                "
                v-model.number="filter.value.max"
                min="0"
              />
              <input
                v-if="
                  filter.label.toLowerCase() ===
                  geoWerftData.texts.filter_label_rooms.toLowerCase()
                "
                type="number"
                value=""
                v-bind:step="get_correct_step(filter.label)"
                v-bind:id="filterIndex + '-max'"
                v-bind:name="filterIndex + '-max'"
                v-bind:placeholder="
                  get_pre_filter_labels('', 'bis') + filter.rooms_max_extension
                "
                v-model.number="filter.value.max"
                min="0"
              />
              <input
                v-if="
                  [
                    geoWerftData.texts.filter_label_space,
                    geoWerftData.texts.filter_space_label_house,
                    geoWerftData.texts.filter_space_label_grundstueck,
                    geoWerftData.texts.filter_space_label_gewerbe,
                    geoWerftData.texts.filter_space_label_invest,
                  ].includes(filter.label)
                "
                type="number"
                value=""
                v-bind:step="get_correct_step(filter.label)"
                v-bind:id="filterIndex + '-max'"
                v-bind:name="filterIndex + '-max'"
                v-bind:placeholder="
                  get_pre_filter_labels('', 'bis') + filter.space_max_extension
                "
                v-model.number="filter.value.max"
                min="0"
              />
              <p>{{ geoWerftData.filter[filterIndex].max }}</p>
            </li>
          </ul>
        </template>
      </li>

      <li
        class="list-map-switcher mw-geo-remove-scroll-bar"
        v-if="geoWerftData.checkboxes.list_map_switcher"
      >
        <div class="geowerft-switcher-buttons-wrapper">
          <div class="geowerft-switcher-buttons-inner">
            <button
              v-on:click="
                handle_listen_click(1, true, geoWerftData.filter, 'list')
              "
              class="geowerft-switcher-tablinks geowerft-switcher-left"
            >
              Listenansicht
            </button>
            <button
              v-on:click="
                handle_listen_click(
                  init_zoom,
                  false,
                  geoWerftData.filter,
                  'map'
                )
              "
              class="geowerft-switcher-tablinks geowerft-switcher-right active"
            >
              Kartenansicht
            </button>
          </div>
        </div>
      </li>

      <li>
        <button @click="geolocate()" style="float: right">Mein Standort</button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      init_zoom: this.geoWerftData.map.zoom,
      display_filter: false,
    };
  },
  props: ["geoWerftData"],
  mounted() {
    // this.geolocate();
  },
  created() {
    /**
     * Wenn der nutzer über die Schnellsuche kommt werden hier mögliche Parameter direkt geklickt.
     */
    let urlParams = new URLSearchParams(window.location.search);

    // Für den interaktiven Filter: Direkte GET-Parameter auf Filter mappen
    if (true === this.geoWerftData.interactive_filter_active) {
      // Erst alle direkten Parameter verarbeiten
      for (const [filterKey, filterSettings] of Object.entries(
        this.geoWerftData.filter
      )) {
        const paramValue = urlParams.get(filterKey);
        if (paramValue) {
          let tmpValue = paramValue;

          // Bei Checkboxen als Array setzen
          if (filterSettings.type === "checkbox") {
            tmpValue = [tmpValue];
          }

          // Komma-getrennte Werte in Array umwandeln
          if (paramValue.includes(",")) {
            tmpValue = paramValue.split(",");
          }

          filterSettings.value = tmpValue;
        }
      }

      // Legacy-Parameter für interaktiven Filter
      const legacyParams = {
        "quick-erwerbsart": "erwerbsart",
        "quick-objektarten": "objektart_raw",
        "quick-status": "homepage_status",
        "quick-epass-class": "epass_wertklasse",
        maxPrice: "kaufpreis",
      };

      for (const [legacyKey, newKey] of Object.entries(legacyParams)) {
        const paramValue = urlParams.get(legacyKey);
        if (
          paramValue &&
          paramValue !== "leer" &&
          this.geoWerftData.filter[newKey]
        ) {
          let tmpValue = paramValue;

          // Bei Checkboxen als Array setzen
          if (this.geoWerftData.filter[newKey].type === "checkbox") {
            tmpValue = [tmpValue];
          }

          // Komma-getrennte Werte in Array umwandeln
          if (paramValue.includes(",")) {
            tmpValue = paramValue.split(",");
          }

          if (Array.isArray(tmpValue)) {
            tmpValue = tmpValue.map((val) =>
              val
                .replace("buy", "kauf")
                .replace("rent", "miete")
                .replace("house", "haus")
                .replace("flat", "wohnung")
                .replace("plot", "grundstueck")
            );
          } else {
            tmpValue = tmpValue
              .replace("buy", "kauf")
              .replace("rent", "miete")
              .replace("house", "haus")
              .replace("flat", "wohnung")
              .replace("plot", "grundstueck");
          }

          this.geoWerftData.filter[newKey].value = tmpValue;
        }
      }
    } else {
      // Alter Filter (bestehende Logik)
      let object_type = null;
      let acquisition_type = null;

      // PHP-set defaults via shortcode query attribute.
      if (geowerftSettings.query && geowerftSettings.query["objektart"]) {
        object_type = geowerftSettings.query["objektart"]
          .replace("haus", "house")
          .replace("wohnung", "flat")
          .replace("grundstück", "plot")
          .replace("gewerbe", "business");
      }
      if (geowerftSettings.query && geowerftSettings.query["erwerbsart"]) {
        acquisition_type = geowerftSettings.query["erwerbsart"]
          .replace("kauf", "buy")
          .replace("miete", "rent");
      }

      // URL params take precedence over PHP-set values.
      if (
        urlParams.get("quick_search_sender") === "quick_search_send_post_data"
      ) {
        const url_object_type = urlParams.get("quick-objektarten");
        const url_acquisition_type = urlParams.get("quick-erwerbsart");
        if (url_object_type && url_object_type !== "leer") {
          object_type = url_object_type;
        }
        if (url_acquisition_type && url_acquisition_type !== "leer") {
          acquisition_type = url_acquisition_type;
        }
      }

      if (object_type) {
        this.handel_option_click("objecttype", object_type);
      }
      if (acquisition_type) {
        this.handel_option_click("acquisition", acquisition_type);
      }
    }
  },
  methods: {
    interactive_filter_cb_status_class(current_filter, filter_value) {
      if (current_filter.value.includes(filter_value)) {
        return filter_value.replace("a+", "a-plus") + " active";
      }
      return filter_value.replace("a+", "a-plus");
    },
    mw_get_main_filter_class(geoWerftData) {
      let classname = "mw-interactive-filter no-filters-set";
      if (true === geoWerftData.enable_class_for_diff_view) {
        classname = classname + " erwerbsart-seperate";
      }
      return classname;
    },
    show_dialog_filter() {
      const tmp_dialog = document.querySelector(
        "#mw-interactive-show-all-filter-dialog"
      );
      document
        .querySelectorAll(".interactive-filter-wrapper")
        .forEach(function (current_wrapper) {
          tmp_dialog.append(current_wrapper);
        });
      document
        .querySelector("#mw-interactive-show-all-filter-dialog-wrapper")
        .showModal();
      document
        .querySelector("#mw-interactive-show-all-filter-dialog-wrapper")
        .focus();
      const main_input_container = document.querySelector(
        ".mw-interactive-filter"
      );
      document
        .querySelector("#mw-interactive-show-all-filter-dialog-wrapper")
        .addEventListener("close", function () {
          Array.from(tmp_dialog.querySelectorAll(".interactive-filter-wrapper"))
            .reverse()
            .forEach(function (current_wrapper) {
              main_input_container.prepend(current_wrapper);
            });
        });
    },
    init_show_filter_action(given_config) {
      const current_max_visible_input_wrapper = given_config.visible_count || 4;
      document
        .querySelectorAll(".interactive-filter-wrapper")
        .forEach(function (current_wrapper) {
          const classListArray = Array.from(current_wrapper.classList);
          classListArray.forEach(function (classItem) {
            const matchedNumbers = classItem.match(/\d+/g);
            if (
              matchedNumbers !== null &&
              matchedNumbers >= current_max_visible_input_wrapper
            ) {
              current_wrapper.classList.toggle("hidden_show_filter");
            }
          });
        });
      return given_config.label.inactive;
    },
    trigger_show_more_filter_actions(given_config, $event) {
      $event.target.classList.toggle("inactive");
      if ($event.target.classList.contains("inactive")) {
        $event.target.innerHTML = given_config.label.inactive;
      } else {
        $event.target.innerHTML = given_config.label.active;
      }
      const current_max_visible_input_wrapper = given_config.visible_count || 4;
      document
        .querySelectorAll(".interactive-filter-wrapper")
        .forEach(function (current_wrapper) {
          const classListArray = Array.from(current_wrapper.classList);
          classListArray.forEach(function (classItem) {
            const matchedNumbers = classItem.match(/\d+/g);
            if (
              matchedNumbers !== null &&
              matchedNumbers >= current_max_visible_input_wrapper
            ) {
              current_wrapper.classList.toggle("hidden-show-filter");
            }
          });
        });
    },
    handleCheckboxChange(current_filter, current_input) {
      current_filter.value = [];
      document
        .querySelectorAll(".single-epass-pair input")
        .forEach(function (elm) {
          elm.checked = false;
        });
      switch (current_input.target.value) {
        case "a+":
          current_filter.value = ["a+"];
          break;
        case "a":
          current_filter.value = ["a+", "a"];
          break;
        case "b":
          current_filter.value = ["a+", "a", "b"];
          break;
        case "c":
          current_filter.value = ["a+", "a", "b", "c"];
          break;
        case "d":
          current_filter.value = ["a+", "a", "b", "c", "d"];
          break;
        case "e":
          current_filter.value = ["a+", "a", "b", "c", "d", "e"];
          break;
        case "f":
          current_filter.value = ["a+", "a", "b", "c", "d", "e", "f"];
          break;
        case "g":
          current_filter.value = ["a+", "a", "b", "c", "d", "e", "f", "g"];
          break;
        case "h":
          current_filter.value = ["a+", "a", "b", "c", "d", "e", "f", "g", "h"];
          break;
      }
    },
    handle_field_visibility(
      current_filter,
      current_index_as_class,
      count,
      geoWerftData
    ) {
      let arr_requirements = current_filter.requires || [];
      let tmp_require_check_value;
      let arr_requirements_size = Object.keys(arr_requirements).length;

      // Prüfen, ob noch der "Mehr anzeigen" Button vorhanden ist.
      let visible_by_button_class = "";
      if (
        geoWerftData.show_more_filter &&
        count >= (geoWerftData.show_more_filter.visible_count || 4)
      ) {
        visible_by_button_class = " hidden-show-filter";
      }

      if (arr_requirements_size >= 1) {
        // Hier nun prüfen, welche requirements gegeben sind.
        for (const [tmp_key, tmp_arr_values] of Object.entries(
          arr_requirements
        )) {
          tmp_require_check_value = this.geoWerftData.filter[tmp_key] || [];
          tmp_require_check_value = tmp_require_check_value.value || "";
          if (
            "" === tmp_require_check_value ||
            (!Array.isArray(tmp_require_check_value) &&
              !tmp_arr_values.includes(tmp_require_check_value)) ||
            (Array.isArray(tmp_require_check_value) &&
              !tmp_require_check_value.some((val) =>
                tmp_arr_values.includes(val)
              ))
          ) {
            return (
              "inactive-require-input " +
              current_index_as_class +
              " filter-elm-count-" +
              count +
              visible_by_button_class
            );
          }
        }
      }
      return (
        current_index_as_class +
        " filter-elm-count-" +
        count +
        visible_by_button_class
      );
    },
    interactive_filter_set_selected(
      current_filter,
      current_select_value,
      mode = ""
    ) {
      const tmp_value = current_filter.value || [];
      if (tmp_value.length !== 0 && tmp_value.includes(current_select_value)) {
        // Change Filter Set Status.
        this.remove_filters_not_set(true);
        if ("checkbox" === mode) {
          return "checked";
        }
        return "selected";
      }
    },
    interactive_filter_input_mode(current_filter) {
      const current_format = current_filter.format || "";
      if (
        current_format === "currency" ||
        "number" === current_format ||
        "buildyear_from" === current_format ||
        "buildyear_to" === current_format
      ) {
        return "decimal";
      }
    },
    interactive_filter_format_value(current_filter) {
      if (current_filter.value !== "") {
        // Change Filter Set Status.
        this.remove_filters_not_set();
        if (
          "text" !== (current_filter.format || "") &&
          "" !== (current_filter.format || "")
        ) {
          current_filter.value = this.mw_interactive_format_number_values(
            this.mw_interactive_remove_currency_and_not_working_chars(
              current_filter.value,
              current_filter.format || ""
            ),
            current_filter.format || "",
            current_filter.extension || "",
            current_filter.digits || "0"
          );
        }
      }
    },
    remove_filters_not_set(call_from_init_cb = false) {
      const remove_filter_unset_class = () => {
        if (document.querySelector(".no-filters-set")) {
          document.querySelectorAll(".no-filters-set").forEach(function (elm) {
            elm.classList.remove("no-filters-set");
          });
        }
      };
      if (true === call_from_init_cb) {
        setTimeout(function () {
          remove_filter_unset_class();
        }, 1000);
      } else {
        remove_filter_unset_class();
      }
    },
    mw_interactive_remove_currency_and_not_working_chars(
      curreny_string,
      type = "currency"
    ) {
      let numeric_string = "0";
      if ("number" === type) {
        numeric_string = curreny_string.replaceAll(",", ".");
      }
      if ("buildyear_from" === type || "buildyear_to" === type) {
        return parseInt(curreny_string);
      }
      if ("currency" === type || "area" === type) {
        numeric_string = curreny_string
          .replaceAll(",00", "")
          .replaceAll(".", "");
      }
      return parseFloat(numeric_string);
    },
    mw_interactive_format_number_values(
      value,
      type = "currency",
      extension = "€",
      digits = "0"
    ) {
      digits = parseInt(digits);
      if (value !== "") {
        let options = {};
        switch (type) {
          case "currency":
            options = { style: "decimal", minimumFractionDigits: digits };
            break;
          case "area":
            options = { style: "decimal", minimumFractionDigits: digits };
            break;
          case "buildyear_from":
          case "buildyear_to":
            return parseInt(value);
          default:
            options = { style: "decimal", minimumFractionDigits: digits };
            break;
        }
        value =
          new Intl.NumberFormat("de-DE", options).format(value) +
          " " +
          extension;
      }
      return value;
    },
    get_pre_filter_labels(current_filter, type) {
      let pre_filter_label = current_filter;
      if (
        this.geoWerftData.texts.custom_pre_filter_label_von.length > 0 &&
        type === "von"
      ) {
        pre_filter_label = this.geoWerftData.texts.custom_pre_filter_label_von.trim();
      }
      if (
        this.geoWerftData.texts.custom_pre_filter_label_bis.length > 0 &&
        type === "bis"
      ) {
        pre_filter_label = this.geoWerftData.texts.custom_pre_filter_label_bis;
      }
      return pre_filter_label;
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    handel_option_click(filterIndex, filter_value) {
      // check zoom
      if (
        undefined !== this.geoWerftData.map.zoom_types &&
        this.geoWerftData.map.zoom_types.length > 0
      ) {
        for (let i = 0; i < this.geoWerftData.map.zoom_types.length; i++) {
          let zoom_type = this.geoWerftData.map.zoom_types[i];
          if (
            "" !== zoom_type[0] &&
            zoom_type.type.toLowerCase() === filter_value.toLowerCase()
          ) {
            let curr_zoom = parseInt(zoom_type.zoom);
            if (true === this.isMobile()) {
              curr_zoom = curr_zoom - 1;
            }
            this.geoWerftData.map.zoom = curr_zoom;
            this.geoWerftData.map.center = {
              lat: parseFloat(zoom_type.lat),
              lng: parseFloat(zoom_type.lng),
            };
          }
        }
      }

      if ("acquisition" === filterIndex) {
        if ("buy" === filter_value.toLowerCase()) {
          this.geoWerftData.filter[
            "price"
          ].label = this.geoWerftData.texts.filter_label_price_buy;
        }
        if ("rent" === filter_value.toLowerCase()) {
          this.geoWerftData.filter[
            "price"
          ].label = this.geoWerftData.texts.filter_label_price_rent;
        }
        if ("" === filter_value.toLowerCase()) {
          this.geoWerftData.filter[
            "price"
          ].label = this.geoWerftData.texts.filter_label_price;
        }
      }

      if ("objecttype" === filterIndex) {
        switch (filter_value.toLowerCase()) {
          case "house":
            this.geoWerftData.filter[
              "rooms"
            ].label = this.geoWerftData.texts.filter_space_label_house;
            this.geoWerftData.filter[
              "rooms"
            ].space_max_extension = this.geoWerftData.texts.filter_space_label_house_max_extension;
            break;
          case "plot":
            this.geoWerftData.filter[
              "rooms"
            ].label = this.geoWerftData.texts.filter_space_label_grundstueck;
            this.geoWerftData.filter[
              "rooms"
            ].space_max_extension = this.geoWerftData.texts.filter_space_label_grundstueck_max_extension;
            break;
          case "business":
            this.geoWerftData.filter[
              "rooms"
            ].label = this.geoWerftData.texts.filter_space_label_gewerbe;
            this.geoWerftData.filter[
              "rooms"
            ].space_max_extension = this.geoWerftData.texts.filter_space_label_gewerbe_max_extension;
            break;
          case "investment":
            this.geoWerftData.filter[
              "rooms"
            ].label = this.geoWerftData.texts.filter_space_label_invest;
            this.geoWerftData.filter[
              "rooms"
            ].space_max_extension = this.geoWerftData.texts.filter_space_label_invest_max_extension;
            break;
          default:
            if (this.geoWerftData.filter["rooms"]) {
              this.geoWerftData.filter[
                "rooms"
              ].label = this.geoWerftData.texts.filter_label_rooms;
            }
            break;
        }
      }
    },
    handle_listen_click(zoom, display_filter, current_filter, button) {
      this.geoWerftData.current_map_mode = button;
      this.display_filter = display_filter;
      this.geoWerftData.map.zoom = zoom;
      // Wenn man von der Listenansicht auf die Karte
      if ("map" === button && current_filter.regio) {
        current_filter.regio.value = "";
      }
    },
    geolocate() {
      // Try to get the current position of the user
      navigator.geolocation.getCurrentPosition((position) => {
        // Set the map to this position
        this.geoWerftData.map.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    get_correct_step(used_type) {
      used_type = used_type.toLowerCase();

      var step_val = 1;

      if (used_type.includes("preis") || used_type.includes("kauf")) {
        step_val = this.geoWerftData.step_num_kauf;
      }

      if (used_type.includes("miet")) {
        step_val = this.geoWerftData.step_num_miete;
      }

      if (used_type.includes("zimmer")) {
        step_val = this.geoWerftData.steps_rooms;
      }

      if (used_type.includes("fläche")) {
        step_val = this.geoWerftData.steps_space;
      }

      if (used_type.includes("wohn")) {
        step_val = this.geoWerftData.steps_living_space;
      }

      if (used_type.includes("grund")) {
        step_val = this.geoWerftData.steps_plot_space;
      }

      return step_val;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/objectFilter.vue